// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__jrn_1","options":"AnswerScale_options__3KIAj","selected":"AnswerScale_selected__3M95H"};